import { Subject } from 'rxjs';

import { AudioEditor } from './AudioEditor';

export default class SelectionBox {
  public from = 0;
  public to = 5;

  constructor(
    private readonly audioEditor: AudioEditor,
    private readonly startSubject: Subject<number>,
    private readonly endSubject: Subject<number>,
  ) {
    audioEditor.onWaveformLoaded$.subscribe(() => {
      this.from = audioEditor.options.segment.from;
      this.to = audioEditor.options.segment.to;
    });
  }

  setStart(time: number) {
    if (this.to - time < 1) {
      return;
    }
    let realTime = time;
    if (
      this.audioEditor.segmentBar.isIntroActive &&
      this.audioEditor.segmentBar.introPoint < time
    ) {
      realTime = this.audioEditor.segmentBar.introPoint;
    } else if (
      (this.audioEditor.segmentBar.isMixActive &&
        time > this.audioEditor.segmentBar.mixPoint) ||
      (this.audioEditor.segmentBar.isOutroActive &&
        time > this.audioEditor.segmentBar.outroPoint)
    ) {
      if (!this.audioEditor.segmentBar.isMixActive) {
        realTime = this.audioEditor.segmentBar.outroPoint;
      } else if (!this.audioEditor.segmentBar.isOutroActive) {
        realTime = this.audioEditor.segmentBar.mixPoint;
      } else {
        realTime = Math.min(
          this.audioEditor.segmentBar.mixPoint,
          this.audioEditor.segmentBar.outroPoint,
        );
      }
    } else if (time < 0) {
      this.resetStart();

      return;
    }
    this.from = realTime;
    this.startSubject.next(this.from);
  }

  resetStart() {
    this.from = 0;
    this.startSubject.next(this.from);
  }

  setEnd(time: number) {
    if (time - this.from < 1) {
      return;
    }
    let realTime = time;
    if (
      (this.audioEditor.segmentBar.isIntroActive &&
        this.audioEditor.segmentBar.introPoint > time) ||
      (this.audioEditor.segmentBar.isOutroActive &&
        this.audioEditor.segmentBar.outroPoint > time) ||
      (this.audioEditor.segmentBar.isMixActive &&
        this.audioEditor.segmentBar.mixPoint > time)
    ) {
      realTime = Math.max(
        this.audioEditor.segmentBar.isIntroActive
          ? this.audioEditor.segmentBar.introPoint
          : 0,
        this.audioEditor.segmentBar.isOutroActive
          ? this.audioEditor.segmentBar.outroPoint
          : 0,
        this.audioEditor.segmentBar.isMixActive
          ? this.audioEditor.segmentBar.mixPoint
          : 0,
      );
    }
    if (time > this.audioEditor.waveformData?.duration) {
      this.resetEnd();

      return;
    }
    this.to = realTime;
    this.endSubject.next(this.to);
  }

  resetEnd() {
    if (this.audioEditor.waveformData) {
      this.to = this.audioEditor.waveformData.duration;
      this.endSubject.next(this.to);
    }
  }
}
